import React from "react";
import CountUp from "react-countup";
import { DollarSign, PackageCheck, Star, TrendingUp, Users } from "lucide-react";

import { CustomersReportController } from "../../../../services/controllers/reports";
import { useCustomersReport } from "../../../../store/reports/useCustomersReport";

import { Summary } from "../../../../components/ui/Summary";

export function CustomersReportSummary() {
  const CCustomersReport = CustomersReportController();

  const summary = useCustomersReport((st) => st.data.summary);
  const filter = useCustomersReport((st) => st.data.filter);
  const loading = useCustomersReport((st) => st.data.isLoading);

  const filtered = filter.hasPackage !== "*" || filter.isSubscriber !== "*";

  const clearAll = () => {
    CCustomersReport.setFilter({ hasPackage: "*", isSubscriber: "*" });
    CCustomersReport.filterCustomers();
  };

  return (
    <Summary.Root>
      <Summary.Box
        active={!filtered}
        onClick={filtered ? clearAll : undefined}
      >
        <Summary.Icon icon={Users} />
        <Summary.TextContent>
          <Summary.Title size="big">
            <CountUp end={loading ? 0 : summary.customerTotal} separator="." preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Total de clientes</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

      <Summary.Box
        active={filter.hasPackage === "true"}
        onClick={() => CCustomersReport.toggleFilter("hasPackage", "true")}
      >
        <Summary.Icon icon={PackageCheck} />
        <Summary.TextContent>
          <Summary.Title size="big">
            <CountUp end={loading ? 0 : summary.withPackage} separator="." preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>Tem pacote</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

      <Summary.Box
        active={filter.isSubscriber === "true"}
        onClick={() => CCustomersReport.toggleFilter("isSubscriber", "true")}
      >
        <Summary.Icon icon={Star} />
        <Summary.TextContent>
          <Summary.Title size="big">
            <CountUp end={loading ? 0 : summary.subscribers} separator="." preserveValue useEasing />
          </Summary.Title>
          <Summary.Text>É assinante</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

      {/* KPIs de dinheiro nao filtram: nao existe filtro correspondente */}
      <Summary.Box>
        <Summary.Icon icon={DollarSign} />
        <Summary.TextContent>
          <Summary.Title size="big">
            <CountUp
              end={loading ? 0 : summary.averageTicket}
              prefix="R$ "
              separator="."
              decimal=","
              decimals={2}
              preserveValue
              useEasing
            />
          </Summary.Title>
          <Summary.Text>Ticket médio</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>

      <Summary.Box>
        <Summary.Icon icon={TrendingUp} />
        <Summary.TextContent>
          <Summary.Title size="big">
            <CountUp
              end={loading ? 0 : summary.totalSales}
              prefix="R$ "
              separator="."
              decimal=","
              decimals={2}
              preserveValue
              useEasing
            />
          </Summary.Title>
          <Summary.Text>Receita total</Summary.Text>
        </Summary.TextContent>
      </Summary.Box>
    </Summary.Root>
  );
}
